import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1] as const;

interface SymposiumBandProps {
    imageUrl: string;
    alt: string;
}

/**
 * Full-bleed Symposium band with text overlaid on the image (matching the LE
 * Miami hosts band): high-impact photo, black bottom-scrim, eyebrow + Didot
 * headline + caption.
 */
export default function SymposiumBand({ imageUrl, alt }: SymposiumBandProps) {
    const shouldReduceMotion = useReducedMotion();

    return (
        <motion.section
            className="relative h-[460px] w-full overflow-hidden bg-[#0b2222] sm:h-[560px]"
            initial={shouldReduceMotion ? { opacity: 1 } : { opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: EASE }}
        >
            <img src={imageUrl} alt={alt} className="editorial-filter h-full w-full object-cover object-center" />
            {/* Black scrim for legibility — never teal over a photo. Matches the LE Miami band format. */}
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent pt-32 pb-10">
                <div className="agent-px mx-auto max-w-5xl">
                    <span className="lux-caps lux-caps-sm mb-2 block text-[#F5F5F5]/70">LuxRally Travel Symposium · Miami 2025</span>
                    <p className="lux-body lux-body-sm max-w-2xl leading-relaxed text-[#F5F5F5]/90">
                        Once a year, our advisors gather in Miami to meet our vendor partners, train live, and finally connect in person with the
                        community they&rsquo;ve built online.
                    </p>
                </div>
            </div>
        </motion.section>
    );
}
